// src/App.tsx
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ThemeProvider } from './context/theme'
import CarnivoreRouter from './CarnivoreRouter'
import Sidebar from './components/sidebar'
import TopBar from './components/topbar'
import { useGlobalState } from './context/global'
import LoadingPage from './pages/loading.page'
import { useError } from './context/error'
import { UserService } from './services/user.service'
import { useNavigate } from 'react-router-dom'
import { KnowledgeCenterModal } from './components/modals/knowledge-center.modal'
import { SettingsService } from './services/settings.service'
import TickerDrawer from './components/ticker-drawer'
import { useMediaQuery, useTheme } from '@mui/material'
import MobileNavBar from './components/mobilenav'
import { StyleHelper } from './components/style-helper'
import { BannerService } from './services/banner.service'
import axios from 'axios'
import MaintenancePage from './pages/maintenance.page'
import { StreamService } from './services/stream.service'
import { useStreamStatus } from './context/streamStatus.context'
import { StreamStatus } from './_types/stream-status.type'

function App() {
  const {
    isSidebarOpen,
    isAuthed,
    setUser,
    user,
    setIsAuthed,
    setSettings,
    settings,
    setBanner } = useGlobalState()
  const { setStreamStatus, streamStatus } = useStreamStatus()

  const { setError } = useError()
  const theme = useTheme()
  const [isLoading, setIsLoading] = useState(true)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isDown, setIsDown] = useState(false)
  const userService = new UserService(setError)
  const settingsService = new SettingsService(setError)
  const bannerService = new BannerService(setError)
  const streamService = new StreamService(setError)

  const lastStatusRef = useRef<StreamStatus | null>(null);


  const navigate = useNavigate()

  useEffect(() => {
    _checkUser()

    // const enableAudio = () => {
    //   if (localStorage.getItem('sound-preference') === 'sound') {
    //     setIsMuted(false)
    //   }
    //   document.removeEventListener('click', enableAudio)
    // }

    // document.addEventListener('click', enableAudio)

    // return () => {
    //   document.removeEventListener('click', enableAudio)
    // }
  }, [])

  useEffect(() => {
    if (settings) {
      // ...
    }
  }, [settings])

  // Only set up stream polling once per authenticated user
  const checkStream = useCallback(async () => {
    try {
      const res = await streamService.getStreamStatus();
      const newStatus = res.status;
      if (!newStatus) return;

      const prev = lastStatusRef.current;
      // only update when either state or streamId changes
      if (
        !prev ||
        prev.state !== newStatus.state ||
        prev.streamId !== newStatus.streamId
      ) {
        setStreamStatus(newStatus);
        lastStatusRef.current = newStatus;
      }

      // detect new LIVE stream
      if (
        newStatus.state === 'LIVE' &&
        prev?.streamId !== newStatus.streamId
      ) {
        // TODO: GO TO STREAM
      }
    } catch (error) {
      // setError(error)
    }
  }, [streamService, setStreamStatus]);

  useEffect(() => {
    if (!user?.isAxxess) return;

    // run immediately, then every 10s
    checkStream();
    const intervalId = setInterval(checkStream, 10_000);

    return () => clearInterval(intervalId);
  }, [user?.isAxxess, checkStream]);

  const _checkUser = async () => {
    const healthResponse = await axios
      .get(process.env.REACT_APP_API_URL as string)
      .then(() => true)
      .catch(() => false)
    if (!healthResponse) {
      setIsDown(true)
      setIsLoading(false)
      return
    }
    const response = await userService.getUser()
    const settingsResponse = await settingsService.getSettings()

    if (settingsResponse.settings) {
      setSettings(settingsResponse.settings)
    }
    setTimeout(() => {
      if (!response.user) {
        setIsLoading(false)
        if (!window.location.href.includes('/logout') && !window.location.href.includes('/forgot')) {
          navigate(`/login${window.location.search}`)
        }
      } else {
        bannerService.getCurrentBanner().then(res => {
          setBanner(res?.banner)
        })

        setUser(response.user)
        setIsAuthed(true)
        if (!response.subscription) {
          if (!response.user.isOnboarded) {
            navigate('/no-sub')

          } else {
            navigate('/no-sub')
          }
          setIsLoading(false)
          return
        }
        const location = window.location.href
        if (location.includes('/login')) {
          navigate('/dashboard')
          setIsLoading(false)
        }
        setIsLoading(false)
      }
    }, 300)
  }

  return (
    <ThemeProvider>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <>
          {isDown ? (
            <MaintenancePage />
          ) : isAuthed &&
            !window.location.href.includes('/signup') &&
            !window.location.href.includes('/no-sub') ? (
            <>
              {isMobile ? (
                <>
                  <MobileNavBar />
                  <TopBar />
                  <StyleHelper.SmallVerticalSpace />
                  <CarnivoreRouter />
                </>
              ) : (
                <>
                  <Sidebar />
                  <div style={{ marginLeft: isSidebarOpen ? 240 : 56 }}>
                    <TopBar />
                    <CarnivoreRouter />
                  </div>
                </>
              )}
            </>
          ) : (
            <CarnivoreRouter />
          )}
          <TickerDrawer />
          <KnowledgeCenterModal />
        </>
      )}
    </ThemeProvider>
  )
}

export default App
